import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Button, Table } from "react-bootstrap";
import { RootState } from "../reducers";
import { useNavigate } from "react-router-dom";
import { setLogin } from "../actions/shopActions";
import { fetchMyOrders } from "../actions/orderActions";
import Loading from "./Loading";
import { useParams } from "react-router-dom";
import { formatPrice } from "./utilities";

const MyOrders = () => {
  const { cell_phone = "", client_id = "" }: any = useParams();
  const myOrders = useSelector((state: RootState) => state.shop.myOrders);
  const isLogued = useSelector((state: RootState) => state.shop.isLogued);
  const cellPhoneStorage = localStorage.getItem("cell_phone");
  const clientIdStorage = localStorage.getItem("client_id");
  const dispatch: any = useDispatch();
  const navigate: any = useNavigate();

  useEffect(() => {
    if (!isLogued && !cell_phone && !client_id) {
      navigate("/login");
    } else {
      if (cell_phone && client_id) {
        dispatch(setLogin({ isLogued: true }));
        localStorage.setItem("cell_phone", cell_phone);
        localStorage.setItem("client_id", client_id);
      }
      dispatch(
        fetchMyOrders({
          cell_phone: cell_phone || cellPhoneStorage,
          client_id: client_id || clientIdStorage,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <h2>Mis pedidos</h2>
      {myOrders?.length > 0 ? (
        <Table bordered className="text-center align-middle">
          <thead>
            <tr>
              <th>Pedido</th>
              <th>Estado</th>
              <th>Total</th>
              <th>Detalle</th>
            </tr>
          </thead>
          <tbody>
            {myOrders?.map((order, index) => (
              <tr key={index}>
                <td>
                  {`#${order.number} `}
                  {new Date(order.date + "T00:00:00").toLocaleDateString(
                    "es-AR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    }
                  )}
                </td>
                <td>
                  <span>
                    {order.status_details[order.status_details.length - 1]
                      ?.sale_status.name || "Entregado"}{" "}
                  </span>
                </td>
                <td>${formatPrice(order.total)}</td>
                <td>
                  <Button
                    className="btn-light"
                    onClick={() =>
                      navigate(`/tracking-sale/${order.id}/${order.client_id}`)
                    }
                  >
                    Ver
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Loading />
      )}
    </Container>
  );
};
export default MyOrders;
